import React from 'react';
import PropTypes from 'prop-types';

export const EmptyCell = ({value}) => (
  <td>{value || '-'}</td>
);
EmptyCell.propTypes = {
  value: PropTypes.any
};
